<template>
  <div>
    <div class="space-y-3">
      <span class="text-text-neutral-tertiary text-xs">
        {{ t('passengerDataForm.document.label') }}
      </span>
      <FreeButton
        type="button"
        class="bg-situational-lightgrey h-13 flex w-full justify-between"
        @click="openDocTypeBottomSheet"
      >
        <span class="truncate text-left text-base">
          {{ t(`passengerDataForm.document.type.${documentType}`) }}
        </span>
        <img
          src="../../../assets/images/chevron-arrow.svg"
          width="24"
          height="24"
          alt=""
        />
      </FreeButton>
    </div>
    <DocumentsSelectBottomSheet
      class="top-auto h-screen"
      :name="docTypeBottomSheetName"
      :selected-doc-type="documentType"
      :fare-type="fareType"
      @onDocumentTypeSelect="emit('onDocumentTypeSelect', $event)"
    />
  </div>
</template>

<script setup lang="ts">
  import { v4 as uuid } from 'uuid';
  import { FreeButton } from 'freedom-shared';
  import { controllerModel } from 'shared';
  import { useI18n } from 'vue-i18n';

  import DocumentsSelectBottomSheet from './DocumentsSelectBottomSheet.vue';
  import type { rwPassengersDataTypes as passengersDataTypes } from '../../../entities/rw-passengers-data';

  defineProps<{
    documentType: passengersDataTypes.DocumentType;
    fareType: string;
  }>();

  const emit = defineEmits<{
    onDocumentTypeSelect: [passengersDataTypes.DocumentType];
  }>();

  const { t } = useI18n();

  const bottomSheet = controllerModel.useBottomSheet();
  // One page may contain several bottom sheets, so we need unique id for every bottom sheet
  const docTypeBottomSheetName = `document-type-bottom-sheet-${uuid()}`;
  const openDocTypeBottomSheet = () => bottomSheet.show(docTypeBottomSheetName);
</script>

<i18n src="../config/locales.json"></i18n>
